import React, { useState } from 'react'
import { useFormik } from 'formik'
import styles from './styles.module.scss'
import CloseIcon from '@material-ui/icons/Close'
import { TextField, Select, MenuItem } from '@material-ui/core'
import { ErrorMessage } from 'components/'
import AsyncButton from 'utils/AsyncButton'
import { userRegistrationInitialValues } from 'utils/formik/initialValues'
import { userRegistrationValidationSchema } from 'utils/formik/validationSchema'
import {
  USER_CREATE_SUCCESS_MESSAGE,
  COGNITO_ERROR_MESSAGE,
  COGNITO_USER_NAME_EXISTS_ERROR_MESSAGE
} from 'const'
import { createUser } from 'api/users'
import { useHistory } from 'react-router-dom'

export interface Props {
  closeModal: () => void
}

const UserRegistrationModal = ({ closeModal }: Props) => {
  const history = useHistory()
  const [
    isUserRegistrationSubmitInProgress,
    setIsUserRegistrationSubmitInProgress,
  ] = useState<boolean>(false)
  const userRegistrationFormik = useFormik({
    initialValues: userRegistrationInitialValues,
    validationSchema: userRegistrationValidationSchema,
    onSubmit: async (values) => {
      setIsUserRegistrationSubmitInProgress(true)
      await createUser(values)
        .then(() => {
          alert(USER_CREATE_SUCCESS_MESSAGE)
          history.go(0)
        })
        .catch((err) => {
          console.error(err)
          if (
            err.response && err.response.data?.error === COGNITO_USER_NAME_EXISTS_ERROR_MESSAGE
          ) {
            alert(COGNITO_USER_NAME_EXISTS_ERROR_MESSAGE)
          } else {
            alert(COGNITO_ERROR_MESSAGE)
          }
        })
      setIsUserRegistrationSubmitInProgress(false)
    },
  })

  return (
    <>
      <div>
        <CloseIcon fontSize="large" className={styles.closeImg} onClick={closeModal} />
      </div>
      <div className={styles.modalBox}>
        <p className={styles.header}>ユーザー追加</p>
        <div className={styles.contentBox}>
          <div>
            <p>
              Eメールアドレス<span className={styles.required}>必須</span>
            </p>
            <TextField
              fullWidth
              type="text"
              variant="outlined"
              {...userRegistrationFormik.getFieldProps('email')}
              onChange={(event) =>
                userRegistrationFormik.setFieldValue('email', event.target.value)
              }
              error={
                !!(userRegistrationFormik.touched.email && userRegistrationFormik.errors.email)
              }
            />
            <ErrorMessage
              touched={userRegistrationFormik.touched.email}
              error={userRegistrationFormik.errors.email}
            />
          </div>
          <div>
            <p>
              氏名<span className={styles.required}>必須</span>
            </p>
            <TextField
              fullWidth
              type="text"
              variant="outlined"
              {...userRegistrationFormik.getFieldProps('name')}
              onChange={(event) => userRegistrationFormik.setFieldValue('name', event.target.value)}
              error={!!(userRegistrationFormik.touched.name && userRegistrationFormik.errors.name)}
            />
            <ErrorMessage
              touched={userRegistrationFormik.touched.name}
              error={userRegistrationFormik.errors.name}
            />
          </div>
          <div>
            <p>
              権限<span className={styles.required}>必須</span>
            </p>
            <Select
              className={styles.select}
              id="group"
              value={userRegistrationFormik.values.group || ''}
              onChange={(event) => userRegistrationFormik.setFieldValue('group', event.target.value)}
              error={!!(userRegistrationFormik.touched.group && userRegistrationFormik.errors.group)}
            >
              <MenuItem value="supervisor">supervisor</MenuItem>
              <MenuItem value="advisor">advisor</MenuItem>
            </Select>
            <ErrorMessage
              touched={userRegistrationFormik.touched.group}
              error={userRegistrationFormik.errors.group}
            />
          </div>
          <div>
            <AsyncButton
              type="button"
              variant="contained"
              color="primary"
              className={styles.addButton}
              onClick={async () => {
                await userRegistrationFormik.validateForm()
                userRegistrationFormik.handleSubmit()
              }}
              loading={isUserRegistrationSubmitInProgress}
            >
              追加
            </AsyncButton>
          </div>
        </div>
      </div>
    </>
  )
}
export default UserRegistrationModal
